import { useQuery } from '@tanstack/react-query';

import { FileSystemService } from './fileSystemService';
import { FileSystemKey } from './keys';

export function useSearchFileSystem(name: string, enabled: boolean = true) {
  return useQuery({
    queryKey: [FileSystemKey.FILE_SEARCH, name],
    queryFn: () => FileSystemService.searchFileSystem(name).then((response) => response.data),
    enabled: enabled,
  });
}
